import React from 'react';

const LandingFooter = () => {
  return (
    <footer className="bg-[var(--color-foreground)] text-gray-400 py-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm"
              style={{ background: 'linear-gradient(135deg, #2D5A87 0%, #E67E22 100%)' }}
            >
              JF
            </div>
            <span className="text-white font-semibold">JOB_Fusion</span>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors">Contact Us</a>
            <a href="#" className="hover:text-white transition-colors">Help Center</a>
          </div>

          <div className="text-sm">
            © {new Date()?.getFullYear()} JOB_Fusion. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
